import { Tag } from "common/components/ui/Tag";
import { PRICING_PLANS } from "common/constants";
import type { PricingPeriodInfo } from "common/types";

import SubscriptionPlanIcon from "./SubscriptionPlanIcon";

import type { JSX } from "react";

export default function SubscriptionPlan({
  plan,
  pricingPeriodInfo,
}: {
  plan: keyof typeof PRICING_PLANS;
  pricingPeriodInfo?: PricingPeriodInfo;
}) {
  const { name, description } = PRICING_PLANS[plan];

  let pricingPeriodInfoComponent: JSX.Element;

  if (pricingPeriodInfo) {
    const { period, period_unit } = pricingPeriodInfo;

    let label = period_unit === "month" ? "Monthly" : "Yearly";

    if (period > 1) {
      label = `${period} ${period_unit}s`;
    }

    pricingPeriodInfoComponent = (
      <Tag variant="quaternary" size="sm">
        {label}
      </Tag>
    );
  }

  return (
    <div className="flex gap-x-2.5 px-2 mb-4">
      <SubscriptionPlanIcon plan={plan} size="sm" />
      <div className="flex flex-col items-start gap-y-1">
        <div className="flex items-center gap-x-1">
          <h3 className="text-md-bold">{name}</h3>
          {pricingPeriodInfoComponent}
        </div>
        <p className="text-xs-medium text-black-500">{description}</p>
      </div>
    </div>
  );
}
